import { Buildings, resourcesFolder, settingsData, threeJsVariables } from '../../settings';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import { isOneMesh, lazyLoadingData } from '../../functions';
import {
    Color,
    EquirectangularReflectionMapping,
    Box3,
    Group,
    Matrix4,
    RepeatWrapping,
    Euler,
    Quaternion, Vector3, DynamicDrawUsage, InstancedMesh, Mesh, BoxGeometry, MeshBasicMaterial, LinearSRGBColorSpace,
} from 'three';
import {SelectedObjectType} from "../../common";
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { Building, OneMeshBuildings } from '../building/Building';
import { BuildingOutline } from '../building/BuildingOutline';
import { addBuildingsIntersections } from '../poi/poiCss';

let indexFloor = 0;

export function loadModelTexturesFromAzure(textureLoader) {
    const texturePromiseArray = [];
    const {cdnRepository,projectFolder} = config;
    const textures = config.resources.buildings.textures;
    const url = `${cdnRepository}/${projectFolder}/${resourcesFolder}/textures/building/`;

    for (const key in textures) {
        const texture = lazyLoadingData(textureLoader, url + textures[key].path);
        texture.then(res => res.name = key);
        texturePromiseArray.push(texture);
    }

    return texturePromiseArray;
}

export function loadBuildingModelsFromAzure(manager,dracoLoader) {
    const {cdnRepository,projectFolder} = config;
    const {folder,name,format,count} = config.resources.buildings;
    let localCount = 0;
    let loader;
    const modelsPromiseArray = [];

    switch (format) {
        case 'gltf':
            loader = new GLTFLoader(manager);
            loader.setDRACOLoader(dracoLoader);
            break;
        case 'fbx':
            loader = new FBXLoader(manager);
            break;
    }

    for (let i = 1; i <= count; i++){
        const buildName = `${name}_${i < 10 ? '0' + i : i}`;

        // if (localCount > domains.length - 1) {
        //     localCount = 0;
        // }
        // const url = `${domains[count]}/${buildName}.${buildingModelsFormat}`;
        const url = `${cdnRepository}/${projectFolder}/${folder}/${buildName}.${format}`;
        const model = lazyLoadingData(loader, url);
        modelsPromiseArray.push(model);
        // localCount++;
    }

    return modelsPromiseArray;
}


export const bundle_initAutoBuildingsScript = (group,data,textures)=> {

    let building;

    if (isOneMesh()) {
        addBuildingsIntersections(data);
        building = Buildings.addOneMeshModel(data);
    } else {
        building = new Building(data).create();
    }

    group.add(building);

    new BuildingOutline(building.name);

    return building;


    // data.children = sortFloors(data);
    // const model = data
    // indexFloor = 0;
    // const {newModelGroup, instFloors} = createModel(model, textures);
    //
    //
    // instFloors.length && settingsData.instanced_floors_switch.push(instFloors);
    // group.add(newModelGroup)
    // return newModelGroup
}


export function initAutoBuildingsScript(data) {
    const {format} = config.resources.buildings;
    const {projectRotation} = config.threejs;
    const textures = data.filter(element => element.image);
    let models;

    const projectGroup = new Group();
    projectGroup.name = 'Project Buildings';
    projectGroup.rotation.set(projectRotation.x,projectRotation.y,projectRotation.z);

    switch (format) {
        case 'gltf':

            models = data.filter(element => !element.image).map(element => element.scene.children[0]);
            models.forEach(model => {
                model.children = sortFloors(model);
                indexFloor = 0;
                const {newModelGroup, instFloors} = createModel(model, textures);
                instFloors.length && settingsData.instanced_floors_switch.push(instFloors);
                // threeJsVariables.scene.add(newModelGroup);
                projectGroup.add(newModelGroup);
            });
            threeJsVariables.scene.add(projectGroup);
            threeJsVariables.renderList.reorder();

            break;
        case 'fbx':
            models = data.filter(element => !element.image);
            models.forEach(model => {
                model.children = sortFloors(model);
                indexFloor = 0;
                const {newModelGroup, instFloors} = createModel(model, textures);
                instFloors.length && settingsData.instanced_floors_switch.push(instFloors);
                // threeJsVariables.scene.add(newModelGroup);
                projectGroup.add(newModelGroup);
            });
            threeJsVariables.scene.add(projectGroup);
            threeJsVariables.renderList.reorder();


            break;

    }


    // const models = data.filter(element => !element.image).map(element => element.scene.children[0]);
    // const projectGroup = new Group();
    // projectGroup.name = 'Project Buildings';
    // //For Cnaan env
    // // projectGroup.position.set(19.860,-60,-29.170);
    // // projectGroup.rotation.set(0,1.2,0);
    // // projectGroup.scale.set(1,1,1);
    // models.forEach(model => {
    //     model.children = sortFloors(model);
    //     indexFloor = 0;
    //     const {newModelGroup, instFloors} = createModel(model, textures);
    //     instFloors.length && settingsData.instanced_floors_switch.push(instFloors);
    //     threeJsVariables.scene.add(newModelGroup);
    //     projectGroup.add(newModelGroup);
    // });
    // threeJsVariables.scene.add(projectGroup);
}

export function sortFloors(model) {
    return model.children.sort((prev, next) => prev.position.y - next.position.y);
}

export function createModel(model, textures) {
    const instFloors = [];
    const disappearArr = [];
    const modelName = model.name;

    const newModelGroup = new Group();
    newModelGroup.name = model.name;
    newModelGroup.position.set(model.position.x, model.position.y, model.position.z);
    newModelGroup.scale.set(model.scale.x, model.scale.y, model.scale.z);
    newModelGroup.rotation.set(model.rotation.x, model.rotation.y, model.rotation.z);

    if (model.children.length) {

        addModelTextures(model.children[0], textures);

        model.children.forEach(floor => {
            if (floor.name.match(/floor\d/g)) {
                // const [buildingName, floorName, floorHeight] = floor.name.split('_');
                // const floorHeightInMeter = parseFloat(floorHeight) / 100;
                // let [floorFrom, floorTo] = floorName.split(/\D{1,}/g).splice(1, 2);
                // if (floorTo === undefined) {
                //     floorTo = floorFrom;
                // }
                // const instanceCount = Number(floorTo - floorFrom + 1);
                // const instanceMesh = makeInstanceMesh(floor, instanceCount, instFloors, 'add', floorHeightInMeter);
                const instanceMesh = makeInstanceMesh(floor, undefined, instFloors, 'add',modelName);
                newModelGroup.add(instanceMesh);
            } else {
                const instanceMesh = makeInstanceMesh(floor, 1, instFloors, '',modelName);
                disappearArr.push(instanceMesh);
                newModelGroup.add(instanceMesh);
            }
        });
    } else {
        createBuildingAmenities(model, newModelGroup, textures);
    }

    if (disappearArr.length) {
        settingsData.objectToDisappear.push(disappearArr);
    }

    return {
        newModelGroup,
        instFloors
    };
}

/*
export function rebuildMeshMaterial (model) {
    for (let i=0; i < model.children.length; i++){
        const newMaterial = new MeshStandardMaterial({side:THREE.FrontSide});
        model.children[i].material = newMaterial;
    }
}
*/

function addModelTextures(modelMesh, textures) {
    const globalSettings = config.resources.buildings.texturesSettings;
    const personalSettings = config.resources.buildings.textures;

    textures.forEach(texture => {
        const settings = personalSettings[texture.name];

        modelMesh.material[texture.name] = texture;

        Object.entries(settings).forEach(([key,value])=>{
           if (key !== 'path'){
               modelMesh.material[texture.name][key] = value;
               modelMesh.material[texture.name].wrapS = RepeatWrapping;
               modelMesh.material[texture.name].wrapT = RepeatWrapping;
               modelMesh.material[texture.name].offset.set(0,0);
               modelMesh.material[texture.name].repeat.set(1,1);
           }
        });

        if (texture.name === 'envMap') {
            // const pmremGenerator = new THREE.PMREMGenerator(threeJsVariables.renderer);
            // pmremGenerator.compileEquirectangularShader();
            // modelMesh.material[texture.name] = pmremGenerator.fromEquirectangular(texture).texture;
            // pmremGenerator.dispose();
            modelMesh.material.envMap.mapping = EquirectangularReflectionMapping;
        }
    });

    modelMesh.material.color = new Color().setHex(0xffffff,LinearSRGBColorSpace);

    if (globalSettings){
        Object.entries(globalSettings).forEach(([key,value])=>{
            modelMesh.material[key] = value;
        });
    }
}

function createBuildingAmenities(amenities, projectGroup, textures) {
    const amenitiesName = amenities.name;
    const instanceMesh = makeInstanceMesh(amenities, 1, [], '', amenitiesName);
    projectGroup.add(instanceMesh);
}

function makeInstanceMesh(baseMesh, count, inst_floors, action,modelName) {
    let rotation = new Euler(baseMesh.rotation.x, baseMesh.rotation.y, baseMesh.rotation.z, 'XYZ');
    let rotationQ = new Quaternion().setFromEuler(rotation);
    let matrix = new Matrix4();
    let scale = new Vector3(baseMesh.scale.x, baseMesh.scale.y, baseMesh.scale.z);
    let position;
    let floorHeight = 0;
    let from, to = 0;
    let iteration = (count) ? count : 0;
    let isFloor = false;

    if (baseMesh.name.match(/floor\d/g)) {
        const [buildingName, floorName, modelFloorHeight] = baseMesh.name.split('_');
        const floorHeightInMeter = parseFloat(modelFloorHeight) / 100;
        let [floorFrom, floorTo] = floorName.split(/\D{1,}/g).splice(1, 2);
        if (floorTo === undefined) {
            floorTo = floorFrom;
        }

        from = Number(floorFrom);
        to = Number(floorTo);
        floorHeight = floorHeightInMeter;
        iteration =  to - from;

        if (iteration === 0){
            iteration = 1;
        } else {
            iteration++;
        }
        isFloor = true;
    }

    // const floor = baseMesh.name.split('_')[1];
    // if (floor){
    //     if (floor.match(/floor-\d{1,}/)){
    //         startFloor = Number(floor.match(/-\d{1,}/));
    //     } else {
    //         startFloor = Number(floor.match(/\d{1,}/)[0]);
    //     }
    // }

    let elementBuildingInstance = new InstancedMesh(baseMesh.geometry, baseMesh.material, iteration);
    elementBuildingInstance.instanceMatrix.setUsage(DynamicDrawUsage);

    for (let i = 0; i < iteration; i++) {
        const floorPosY = baseMesh.position.y + i * floorHeight;
        position = new Vector3(baseMesh.position.x, floorPosY, baseMesh.position.z);
        matrix.compose(position, rotationQ, scale);
        elementBuildingInstance.setMatrixAt(i, matrix);
        elementBuildingInstance.renderOrder = 1;

        if (action) {
            inst_floors[indexFloor++] = {
                'name': baseMesh.name,
                'mesh': elementBuildingInstance,
                'count': i,
                'position': {x: position.x, y: position.y, z: position.z},
                'basePosition': {x: position.x, y: position.y, z: position.z},
                'rotation': rotation,
                'diff': {
                    x: 0,
                    y: position.y,
                    z: 0,
                },
                'matrix': matrix,
                'floor': (isFloor) ? from + i : indexFloor,
            };

        }
    }
    elementBuildingInstance.name = `${baseMesh.name}_instance`;
    elementBuildingInstance.userData = {
        type: SelectedObjectType.Building,
        main_building_item: true,
        buildingFloors: true,
    };

    //elementBuildingInstance = setCenterMeshFloor(elementBuildingInstance);

    elementBuildingInstance.frustumCulled = false;
    elementBuildingInstance.receiveShadow = true;
    elementBuildingInstance.castShadow = true;

    return elementBuildingInstance;
}

function setCenterMeshFloor(elementBuildingInstance) {

    const centerGeometry = new BoxGeometry(0.0001, 0.0001, 0.0001);
    const centerMaterial = new MeshBasicMaterial({color: 0xffff00});
    const floorCenter = new Mesh(centerGeometry, centerMaterial);
    floorCenter.name = 'floor_center';
    floorCenter.position.set(0, 0, elementBuildingInstance.position.z);

    if (elementBuildingInstance.type === 'Group') {
        elementBuildingInstance.children.push(floorCenter);
    } else {
        elementBuildingInstance.add(floorCenter);
    }

    return elementBuildingInstance;
}

const computeBoundingBox = (m) => {

    const geometry = m.geometry;
    const count = m.count;

    let box = new Box3()

    if ( geometry.boundingBox === null ) {
        geometry.computeBoundingBox()
    }

    box.makeEmpty()
    let _instanceLocalMatrix = new Matrix4()

    for ( let i = 0; i < count; i ++ ) {

        m.getMatrixAt( i, _instanceLocalMatrix );

        let _box3 = new Box3()
        _box3.copy( geometry.boundingBox ).applyMatrix4( _instanceLocalMatrix )

        box.union( _box3 )

    }
    return box
}

export function addObjectsToOpacity() {
    // const instFloors = settingsData.instanced_floors_switch;


    // buildings_info.forEach(building => {
    //     for (let i = 0; i < instFloors.length; i++) {
    //         const mainBuilding = instFloors[i][0].mesh.parent;
    //         if (mainBuilding.name === building.name) {
    //             mainBuilding.updateWorldMatrix()
    //             let box = new Box3()
    //             box.name = building.name
    //             for (let i=0;i<mainBuilding.children.length;i++){
    //                 box.union(computeBoundingBox(mainBuilding.children[i]))
    //             }
    //             box.applyMatrix4( mainBuilding.matrixWorld )
    //             settingsData.box_to_intersection.push(box)
    //         }
    //     }
    // })

    // buildings_info.forEach(building => {
        // console.log(building);
        // const getBuilding = Buildings[building.name];
        //
        // if (getBuilding){
        //     settingsData.objects_to_intersection.push(...getBuilding.instances);
        //     // building.objects_to_appear.push(...getBuilding.instances);
        // }


        // for (let i = 0; i < instFloors.length; i++) {
        //     const mainBuilding = instFloors[i][0].mesh.parent;
        //
        //     if (mainBuilding.name === building.name) {
        //         building.objects_to_appear.push(mainBuilding);
        //         building.intersections = [...mainBuilding.children];
        //
        //         settingsData.objects_to_intersection.push(...mainBuilding.children);
        //     } else {
        //         building.objects_to_opacity.push(mainBuilding);
        //
        //         settingsData.objects_to_intersection.push(...mainBuilding.children);
        //         settingsData.additionalIntersectionObjects.push(...mainBuilding.children);
        //     }
        // }
    // });
}

// export function addObjectsToOpacity() {
//     buildings_info.forEach(building => {
//         for (let i = 0; i < settingsData.instanced_floors_switch.length; i++) {
//             const instancedBuildingName = settingsData.instanced_floors_switch[i][0].name;
//             if (!instancedBuildingName.startsWith(building.name)) {
//                 settingsData.instanced_floors_switch[i].forEach(item => building.objects_to_opacity.push(item.mesh));
//                 const disappearObj = settingsData.Disappear[i];
//                 building.objects_to_opacity.push(...disappearObj);
//             } else {
//                 settingsData.instanced_floors_switch[i].forEach(item => building.objects_to_appear.push(item.mesh));
//                 const disappearObj = settingsData.Disappear[i];
//                 building.objects_to_appear.push(...disappearObj);
//             }
//         }
//     });
// }
